export default __webpack_public_path__ + "static/media/Address.ca65a814.png";